import {ActionList, ActionMenu} from '@primer/react'
import {Stack} from '@primer/react/drafts'
import {usePlaygroundState} from './playground-manager'
import type {Model} from '../../types'

export function PlaygroundCodeLanguage({
  model,
  handleSelectLanguage,
}: {
  model: Model
  handleSelectLanguage: (language: string) => void
}) {
  const {selectedLanguage} = usePlaygroundState()
  const languages = Object.keys(model.samples.code)
  const snippet = model.samples.code[selectedLanguage as keyof typeof model.samples.code]

  if (!snippet) {
    return null
  }

  return (
    <Stack gap="normal" className="width-fit d-block">
      <ActionMenu>
        <ActionMenu.Button size="small">{snippet.friendly_name}</ActionMenu.Button>
        <ActionMenu.Overlay width="small">
          <ActionList selectionVariant="single">
            {/* For each language, add an item to the dropdown */}
            {languages.map(language => (
              <ActionList.Item
                key={language}
                selected={language === selectedLanguage}
                onSelect={() => {
                  handleSelectLanguage(language)
                }}
              >
                {model.samples.code[language as keyof typeof model.samples.code].friendly_name}
              </ActionList.Item>
            ))}
          </ActionList>
        </ActionMenu.Overlay>
      </ActionMenu>
    </Stack>
  )
}

try{ PlaygroundCodeLanguage.displayName ||= 'PlaygroundCodeLanguage' } catch {}